import { api } from '@/api/client'

export type MembershipRole = 'owner' | 'manager' | 'staff'
export type OrganizationType = 'customer' | 'supplier'

export interface UserProfile {
  id: string
  email: string
  fullName: string
  phone: string | null
  isActive: boolean
  emailVerifiedAt: string | null
  lastLoginAt: string | null
}

export interface MembershipSummary {
  organizationId: string
  organizationName: string
  organizationType: OrganizationType
  role: MembershipRole
  isDefault: boolean
}

export interface Session {
  accessToken: string
  tokenType: string
  expiresAt: string
  user: UserProfile
  organizationId: string | null
  role: MembershipRole | null
  permissions: string[]
  memberships: MembershipSummary[]
}

export interface Me {
  user: UserProfile
  organizationId: string | null
  organizationName: string | null
  organizationType: OrganizationType | null
  role: MembershipRole | null
  permissions: string[]
  memberships: MembershipSummary[]
}

export interface RegisterPayload {
  email: string
  password: string
  fullName: string
  phone?: string
  organizationName: string
  vatNumber?: string
}

export interface LoginPayload {
  email: string
  password: string
  organizationId?: string
}

export const authApi = {
  register: (payload: RegisterPayload) => api.post<Session>('/auth/register', payload),
  login: (payload: LoginPayload) => api.post<Session>('/auth/login', payload),
  refresh: () => api.post<Session>('/auth/refresh'),
  logout: () => api.post<{ message: string }>('/auth/logout'),
  requestMagicLink: (email: string) =>
    api.post<{ message: string }>('/auth/magic-link', { email }),
  verifyMagicLink: (token: string) =>
    api.post<Session>('/auth/magic-link/verify', { token }),
  switchOrganization: (organizationId: string) =>
    api.post<Session>('/auth/switch-organization', { organizationId }),
  me: () => api.get<Me>('/auth/me'),
}
